<script lang="ts">
    import CustomizationManager from "@lib/CustomizationManager/CustomizationManager";
    import { parseIntDataAttr } from "@ui-utils/Injector/utils";
    import { SvelteComponent, getAllContexts, onMount } from "svelte";

    export let Component: typeof SvelteComponent;
    export let componentProps: Record<string, any> = {};
    export let componentContext: ReturnType<typeof getAllContexts> = new Map();
    export let componentListeners: Record<string, (params: any) => any> = {};
    export let selector: string;
    export let shadow = false;
    export let widgetName = "";
    export let customizationManager: CustomizationManager | null = null;
    export let order: number | null = null;

    onMount(async () => {
        const wrapper = document.createElement("div");

        let target;

        if (shadow) {
            target = wrapper.attachShadow({
                mode: "open",
            });
        } else {
            target = wrapper;
        }

        wrapper.style.display = "block";

        const placeholder = document.querySelector<HTMLElement>(selector);

        if (!placeholder) {
            throw new Error(`Cannot find element with selector '${selector}'`);
        }

        if (!order) {
            placeholder.appendChild(wrapper);
        } else {
            wrapper.setAttribute("data-order", order.toString());
            const items = Array.from(
                placeholder.querySelectorAll<HTMLElement>("[data-order]")
            );
            const nextElement = items.find(
                (item) =>
                    order && order < (parseIntDataAttr(item, "order") || 0)
            );

            if (nextElement) {
                placeholder.insertBefore(wrapper, nextElement);
            } else {
                placeholder.appendChild(wrapper);
            }
        }

        const customizationManagerConfig = {
            widgetName,
            placeholder,
            shadowRoot: target instanceof ShadowRoot ? target : undefined,
        };

        customizationManager?.injectStylesFromCustomization(
            customizationManagerConfig
        );
        await customizationManager?.beforeWidgetInject(
            customizationManagerConfig
        );

        const portalElement = new Component({
            target: target,
            props: {
                ...componentProps,
            },
            context: componentContext,
        });

        customizationManager?.afterWidgetInject(customizationManagerConfig);

        for (let event in componentListeners) {
            portalElement.$on(event, componentListeners[event]);
        }
    });
</script>
